import { Component, OnInit } from "@angular/core";
import { environment } from "../../../environments/environment";
import { FormGroup, Validators, FormControl } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { PlanningPokerService } from "../../services/planning-poker/planning-poker.service";

@Component({
  selector: "app-planning-poker-home",
  templateUrl: "./planning-poker-home.component.html",
  styleUrls: ["./planning-poker-home.component.scss"],
})
export class PlanningPokerHomeComponent implements OnInit {
  projectId: string;
  loginForm: FormGroup;
  error: string;
  return = "" as string;
  env: any = environment;
  // name: string;
  // password: string;
  passwordRequired: boolean;
  projectName: string;
  status: number = 0;
  feature: any;
  annotation: any;
  riskIndicator: any;
  results: any;
  consensus: number;
  loading: boolean = false;

  constructor(
    private planningPokerService: PlanningPokerService,
    private route: ActivatedRoute
  ) {
    this.loginForm = new FormGroup({
      name: new FormControl("", Validators.required),
      password: new FormControl("", Validators.required),
    });
  }

  ngOnInit() {
    this.route.params.subscribe(async (params: { id: string }) => {
      this.projectId = params.id;
      try {
        await this.joinProject();
        /* zum ausprobieren
        this.status = 99;
        */
      } catch (ex) {
        console.log(ex);
        console.log(ex.stack);
        this.status = 99;
      }
    });
    this.planningPokerService.reconnected.subscribe(
      async (_) => await this.joinProject()
    );
    this.planningPokerService.estimationStarted.subscribe((featureData) => {
      this.consensus = featureData.consensus;
      this.planningPokerService.selectedValue = null;
      if (featureData.type === "Feature") {
        this.feature = featureData;
        this.annotation = null;
        this.riskIndicator = null;
      } else if (featureData.type === "RiskIndicator") {
        this.feature = null;
        this.annotation = null;
        this.riskIndicator = featureData;
      } else {
        this.feature = null;
        this.annotation = featureData;
        this.riskIndicator = null;
      }
      this.status = 3;
    });
    this.planningPokerService.estimationStopped.subscribe((results) => {
      this.results = results.results;
      this.status = 2;
    });
    this.planningPokerService.consensusSet.subscribe((consensus) => {
      this.consensus = consensus;
    });
    this.planningPokerService.setStatus.subscribe((status) => {
      this.status = status.result.status;
    });
    this.planningPokerService.participantLeft.subscribe((data) => {
      if (data.token === this.planningPokerService.socketIoToken) {
        this.loading = true;
        window.location.reload();
      }
    });
  }

  getTextColor(backColor) {
    backColor = backColor || "#f5f5f5";
    var color =
      backColor.charAt(0) === "#" ? backColor.substring(1, 7) : backColor;
    var r = parseInt(color.substring(0, 2), 16); // hexToR
    var g = parseInt(color.substring(2, 4), 16); // hexToG
    var b = parseInt(color.substring(4, 6), 16); // hexToB
    var uicolors = [r / 255, g / 255, b / 255];
    var c = uicolors.map((col) => {
      if (col <= 0.03928) {
        return col / 12.92;
      }
      return Math.pow((col + 0.055) / 1.055, 2.4);
    });
    var L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
    return L > 0.55 ? "#000" : "#fff";
  }

  async joinProject() {
    try {
      this.loading = true;
      let result = await this.planningPokerService.joinProject(
        this.projectId,
        this.loginForm.get("name").value,
        this.loginForm.get("password").value
      );
      this.projectName = result.projectName;
      this.passwordRequired = result.passwordRequired;
      if (!result.passwordRequired) {
        this.loginForm.get("password").clearValidators();
        this.loginForm.get("password").updateValueAndValidity();
      }
      this.consensus = result.consensus;
      this.status = result.status;
      this.feature = result.feature;
      this.annotation = result.annotation;
      this.riskIndicator = result.riskIndicator;
      this.results = result.results;
      this.planningPokerService.selectedValue = result.estimation;
    } catch (ex) {
      this.error = ex;
    } finally {
      this.loading = false;
    }
  }

  async connect() {
    await this.joinProject();
  }

  async setEstimation(value: string) {
    this.loading = true;
    let result = await this.planningPokerService.setEstimation(value);
    this.planningPokerService.selectedValue = value;
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/planning-poker-home/planning-poker-home.component.ts